import {ValidationException} from '@practicegenius/http-clients-js/src/exceptions';

/** @deprecated use http-clients-js/exceptions.ValidationException instead */
export class CrappyValidationException extends ValidationException {
  // extend ValidationException so instanceof with this works
  constructor(data: Record<string, unknown>) {
    super(
      data,
      // @ts-expect-error The exact point of this class is to set a fake version of the response
      {}
    );
    this.errors = (data.errors ?? {}) as Record<string, string[]>;
    this.data = data;
  }
}
